import { render } from "./Photos.vue?vue&type=template&id=2d9a45dc&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=2d9a45dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9a45dc"]])

export default __exports__